// List types
export const CONTACT_LIST_RESET = 'CONTACT_LIST_RESET';
export const CONTACT_LIST_VIEW = 'CONTACT_LIST_VIEW';
export const CONTACT_LIST_SUCCESS = 'CONTACT_LIST_SUCCESS';

// Pair types
export const PAIR_TOKEN_GET_RESET = 'PAIR_TOKEN_GET_RESET';
export const PAIR_TOKEN_GET_SUCCESS = 'PAIR_TOKEN_GET_SUCCESS';
export const PAIR_TOKEN_ADD_SUCCESS = 'PAIR_TOKEN_ADD_SUCCESS';
export const PAIR_TOKEN_SET_METHOD = 'PAIR_TOKEN_SET_METHOD';

// View types

export const CONTACT_SHOW_ERROR = 'CONTACT_SHOW_ERROR';
export const CONTACT_SHOW_LOADING = 'CONTACT_SHOW_LOADING';
export const CONTACT_SHOW_RESET = 'CONTACT_SHOW_RESET';
export const CONTACT_SHOW_ANSWERS_VIEW = 'CONTACT_SHOW_ANSWERS_VIEW';
export const CONTACT_SHOW_ANSWERS_SUCCESS = 'CONTACT_SHOW_ANSWERS_SUCCESS';
export const CONTACT_SHOW_INFO_SUCCESS = 'CONTACT_SHOW_INFO_SUCCESS';
export const CONTACT_SHOW_STATS_SUCCESS = 'CONTACT_SHOW_STATS_SUCCESS';




// WEBPACK FOOTER //
// ./src/store/modules/contact/mutation-types.js